export enum AppUploadHandlerActionTypes {
  ADD_FILES_TO_UPLOAD = 'ADD_FILES_TO_UPLOAD',
  CREATE_FOLDER = 'CREATE_FOLDER',
  PROCESS_QUEUE = 'PROCESS_QUEUE',
  INCREMENT_UPLOAD_IN_PROGRESS = 'INCREMENT_UPLOAD_IN_PROGRESS',
  DECREMENT_UPLOAD_IN_PROGRESS = 'DECREMENT_UPLOAD_IN_PROGRESS',
  REDO_FILE_UPLOAD = 'REDO_FILE_UPLOAD',
  CANCEL_ALL = 'CANCEL_ALL',
  CANCEL_FILE = 'CANCEL_FILE',
  UPLOAD_FINISHED = 'UPLOAD_FINISHED',
}
